import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SectionConfig } from '../models/section.interface';
import { FieldConfig } from '../models/field.interface';
import { SubFormComponent } from '../sub-form/sub-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RFFConstants } from '../constants';
@Component({
  selector: 'app-input',
  template: `
<div [formGroup]="group" class="panel-group" id="accordion" *ngIf="!section.dynamic">
  <div class="hazard-description section-field panel">
    <a class="accordion-toggle"  data-toggle="collapse" [attr.data-target]="'#singleSection' + index">
      <p>{{section.name}}</p>
    </a>
    <div id="singleSection{{index}}" [ngClass]="{in: index === 0}" class="panel-collapse collapse">
      <ng-container *ngFor="let field of section.fields;let i = index" appField [field]="field" [group]="group"> </ng-container>
    </div>
  </div>
</div>
<div [formGroup]="group" class="dynamic-sections" *ngIf="section.dynamic">
  <p class="dyanmic-title dynamic-paragraph" [ngClass]="{'editbility' : !section.style.editability}">{{section.name}}<img (click)="dynamicSection()" src="assets/rff-images/bulk.png"></p>
    <ng-container *ngFor="let data of dynamicSections;let sectionIndex = index">
      <div class="panel-group" id="accordion1">
        <div class="hazard-description section-field panel">
          <div class="dynamic-paragraph">
            <input type="text" [ngModel]="getSectionTitle(sectionIndex)" [ngModelOptions]="{standalone :true}" [ngClass]="{'linkdisabled' : getSectionTitle(sectionIndex),'bg-clr' : getSectionTitle(sectionIndex)}" class="form-control title-field">
            <div class="cancel-add-date" *ngIf="section.style.editability">
              <img src="assets/rff-images/new-edit.png" (click)="editText(sectionIndex)" *ngIf="getSectionTitle(sectionIndex)" style="height: 16px;margin: 9px 10px;">
              <img src="assets/rff-images/delt.png" (click)="deletSection(sectionIndex)" *ngIf="getSectionTitle(sectionIndex)" style="height: 16px;margin: 0px 42px 0 0;">
            </div>
            </div>
            <a *ngIf="getSectionTitle(sectionIndex)" class="accordion-toggle"  data-toggle="collapse"  [attr.data-target]="'#collapseOne'+sectionIndex+ section.id" aria-expanded="true">
          </a>
            <div id="collapseOne{{ sectionIndex }}{{section.id}}" [ngClass]="{in: sectionIndex === 0}" class="panel-collapse collapse">
              <ng-container *ngFor="let field of section.fields; let fieldIndex = index" appField [field]="updateField(field, sectionIndex, fieldIndex)" [group]="group"> </ng-container>
            </div>
          </div>
        </div>
    </ng-container>
</div>
`,
  styles: [`.section-field{background: #FFF;margin-bottom: 20px;padding: 10px 20px;position: relative;}.section-field p{ margin:0}.panel-group{margin:0}.editbility{pointer-events:none;cursor:default}`]
})
export class SectionComponent implements OnInit {
  section: SectionConfig;
  group: FormGroup;
  editedIndex: number;
  dynamicSections = [];
  sectionTitle;
  showSection: boolean;
  constructor(
    private modalService: NgbModal,
    private constants: RFFConstants
  ) {
  }


  deletSection(index) {
    this.dynamicSections.splice(index, 1);
  }


  getSectionTitle(sectionIndex) {
    // const data = this.dynamicSections[sectionIndex];

    // if (data[this.section.id + '_title']) {
    //   return data[this.section.id + '_title'];
    // }
    return sectionIndex + 1;
  }
  updateField(field: FieldConfig, sectionIndex, fieldIndex) {

    const data = this.dynamicSections[sectionIndex]

    if (data[field.id]) {
      field.value = data[field.id];
    } else {
      if (field.section.dynamic) {
        field.value = " ";
      }
    }

    // if (field.type === this.constants.RFF_ELEMENT_TYPE.SectionTitle) {
    //   field.style.visibility = false;
    //   this.sectionTitle = field.value ? field.value : '';
    // }
    field.style.editability = false;

    return field
  }

  ngOnInit() {

    if (this.section.dynamic === true && this.section.value) {
      this.dynamicSections = this.section.value;
    }
  }
  editText(sectionIndex) {
    //this.showSection = false;

    this.dynamicSection(sectionIndex);
  }

  dynamicSection(sectionIndex) {

    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-large',
    };
    const modalRef = this.modalService.open(
      SubFormComponent,
      modalOptions
    );

    const template = `{
      "category": "",
      "displayFields": [],
      "name": "",
      "rFFSchema": {
        "layout": {},
        "schema": {
          "01_prefill_form_with_asset_field_form": [
            {
              "01_prefill_form_with_asset_field_form_new_page0": [
                {{SECTION}}
              ],
              "meta": {
                "title": "New Page"
              }
            }
          ]
        },
        "styles": {},
        "validation": {{VALIDATIONS}}
      }
    }`

    let self = this;
    var old = template.replace(/{{SECTION}}/g, function () {
      return JSON.stringify(self.section.json);
    });
    old = old.replace(/{{VALIDATIONS}}/g, function () {
      return JSON.stringify(self.section.formValidationJson);
    });
    var newTemplateJson = JSON.parse(old);

    modalRef.componentInstance.template = newTemplateJson;
    modalRef.componentInstance.subFormPreview = true;

    if (this.dynamicSections[sectionIndex]) {
      this.editedIndex = sectionIndex;
      modalRef.componentInstance.data = this.dynamicSections[sectionIndex];
    }

    modalRef.componentInstance.isEditable = this.section.style.editability;

    modalRef.result.then((data) => {

      if (this.dynamicSections[this.editedIndex]) {
        this.dynamicSections[this.editedIndex] = data.data;
        this.editedIndex = undefined;
      } else {
        this.dynamicSections.push(data.data);
        this.section.value = this.dynamicSections;
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/section/section.component.ts